import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-language-redirect',
  templateUrl: './language-redirect.component.html',
  styleUrls: ['./language-redirect.component.scss']
})
export class LanguageRedirectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
